import { useAssembliesContext } from "#modules/quoteRequests/context/AssembliesContext";

export const useCurrentAssembly = (quoteRequestLineId: string | undefined) => {
  const { assemblies } = useAssembliesContext();

  const currentAssembly = assemblies.find(
    (assembly) => assembly.quoteRequestLine.id === quoteRequestLineId,
  );

  return currentAssembly;
};
